import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { GERENCIAMENTO_VIAGEM_BASE_ROUTES } from './gerenciamento-viagem-base.route';
import { addRoutesWhenAnyFeatureEnabled } from '../../shared/routes/feature-routes.util';

export const GERENCIAMENTO_VIAGEM_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    addRoutesWhenAnyFeatureEnabled(
      routesService,
      configState,
      ['cargo_fleet.GerenciamentoViagensNovo'],
      [...GERENCIAMENTO_VIAGEM_BASE_ROUTES],
    );
  };
}
